import { apiUrl } from "../../../setting";

export const getDayBookUrl = () => {
    return `${apiUrl}/routes/daybook/getDayBookRecord`;
};
